import { FloorplanImage } from "@domain/project/floorplan/floorplan-image";
import { FloorplanItemTextKonva } from "@project/floorplanner/konva/floorplan-item-text-konva";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { LabelLayoutKonva } from "@project/floorplanner/konva/label-layout-konva";
import Konva from "konva";
import { Group } from "konva/lib/Group";
import { Text } from "konva/lib/shapes/Text";

export class ImageKonva {
  static init(floorplanImage: FloorplanImage, img: Konva.Image): Group {
    const parentGroup = new Group();

    const imgGroup = new Group({
      id: floorplanImage.id,
      x: floorplanImage.x,
      y: floorplanImage.y,
      stroke: "black",
      strokeWidth: 1,
      draggable: false,
      [FloorplanWorkspaceKonvaAdapter.OBJECT_KEY]: floorplanImage,
    });

    this.initImage(img, floorplanImage, imgGroup);
    const positionId = this.initPositionIdText(floorplanImage, img, imgGroup);
    this.initEventListener(imgGroup, img, positionId, floorplanImage);

    parentGroup.add(imgGroup);
    parentGroup.add(positionId);
    this.setTextPosition(positionId, imgGroup);
    return parentGroup;
  }

  private static initImage(img: Konva.Image, floorplanImage: FloorplanImage, imgGroup: Group) {
    imgGroup.setAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY, floorplanImage);
    if (img.getHeight() == 0) {
      img.height(floorplanImage.size);
      img.width(floorplanImage.size);
    }

    const scale = floorplanImage.size / img.getWidth();
    img.scaleX(scale);
    img.scaleY(scale);

    imgGroup.add(img);
  }

  private static initPositionIdText(floorplanImage: FloorplanImage, img: Konva.Image, imgGroup: Group) {
    const positionId = FloorplanItemTextKonva.init(floorplanImage);
    const text = FloorplanItemTextKonva.getText(positionId);
    this.scaleText(text, imgGroup, img);
    FloorplanItemTextKonva.updateBackground(positionId);
    this.setTextPosition(positionId, imgGroup);
    return positionId;
  }

  static setTextPosition(itemText: Group, imgGroup: Konva.Group) {
    const item = imgGroup.getAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY);
    LabelLayoutKonva.placeLabelForItem(itemText, imgGroup, item);
  }

  private static initEventListener(imgGroup: Group, img: Konva.Image, positionId: Group, floorplanImage: FloorplanImage) {
    const text = FloorplanItemTextKonva.getText(positionId);
    imgGroup.on("transform", () => {
      this.scaleText(text, imgGroup, img);
      FloorplanItemTextKonva.updateBackground(positionId);
      this.setTextPosition(positionId, imgGroup);
    });
    imgGroup.on("dragmove", () => {
      this.setTextPosition(positionId, imgGroup);
    });
    imgGroup.on("transformend", () => {
      const width = img.width() * img.scaleX() * imgGroup.scaleX();
      floorplanImage.updateSize(width, imgGroup.x(), imgGroup.y());
    });
  }

  static refreshItemText(floorplanImage: FloorplanImage, group: Group) {
    const imgGroup = group.findOne(`#${floorplanImage.id}`) as Konva.Group | null;
    const itemText = group.findOne(".itemText") as Group | null;
    const img = imgGroup?.findOne("Image") as Konva.Image | null;
    if (!imgGroup || !img || !itemText) {
      return;
    }
    FloorplanItemTextKonva.refreshText(floorplanImage, itemText);
    this.setTextPosition(itemText, imgGroup);
  }

  private static scaleText(itemText: Text, imageGroup: Konva.Group, image: Konva.Image) {
    itemText.fontSize((image.height() * imageGroup.scaleY() * image.scaleY()) / 10);
  }
}
